/**
 * API client helper — automatically includes CSRF token on mutation requests.
 * Usage: import { apiFetch } from '../utils/api'; then use apiFetch(url, options)
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${BACKEND_URL}${path}`;
  const method = (options.method || 'GET').toUpperCase();
  
  const headers = { ...(options.headers || {}) };
  
  // Default Content-Type when a body is a string (JSON) and caller didn't set one.
  // Fixes 422 "Input should be a valid dictionary" when callers pass JSON.stringify
  // without an explicit Content-Type header.
  if (options.body && typeof options.body === 'string'
      && !Object.keys(headers).some((h) => h.toLowerCase() === 'content-type')) {
    headers['Content-Type'] = 'application/json';
  }
  
  // Add CSRF token for state-changing requests
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
    const csrf = getCsrfToken();
    if (csrf) {
      headers['X-CSRF-Token'] = csrf;
    }
  }
  
  return fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  });
}

/**
 * Helper to get CSRF token value (for components that build their own fetch)
 */
export function getCSRFHeaders() {
  const csrf = getCsrfToken();
  return csrf ? { 'X-CSRF-Token': csrf } : {};
}
